import AliasCard from "./AliasCard";

export default AliasCard;